import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { SearchIcon } from '../Icons';

import Styles from './index.module.scss';

interface Props extends React.ComponentPropsWithRef<'input'> {
	param?: string;
	delay?: number;
	replace?: boolean;
	className?: string;
}

export const SearchQueryInput = ({
	className,
	param = 'filter',
	delay = 300,
	replace = true,
	...props
}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const urlValue = searchParams.get(param) ?? '';
	const [value, setValue] = useState(urlValue);

	useEffect(() => {
		setValue(urlValue);
	}, [urlValue]);

	useEffect(() => {
		const id = setTimeout(() => {
			const next = value.trim();
			const nextParams = new URLSearchParams(searchParams);
			if (next) nextParams.set(param, next);
			else nextParams.delete(param);

			if (nextParams.toString() !== searchParams.toString()) {
				setSearchParams(nextParams, { replace });
			}
		}, delay);

		return () => clearTimeout(id);
	}, [value, delay, param, searchParams, setSearchParams, replace]);

	return (
		<div className={`${Styles.container} ${className ?? ''}`}>
			<SearchIcon />
			<input {...props} value={value} onChange={(e) => setValue(e.target.value)} />
		</div>
	);
};
